import { Loading } from 'screens/VirtualMarketerOnboarding/Loading/Loading'
import AutopilotRegistrationAndOnboardingStyles from 'screens/AutopilotRegistration/AutopilotRegistrationAndOnboarding.module.scss'

import { useProgress } from 'hooks/useProgress'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const LoadingAnimation = ({ handleBack }: { handleBack: () => void }) => {
  const { isMobile } = useResponsiveDesign()

  const {
    start: startThree,
    isRunning: isRunningThree,
    progress: progressThree,
  } = useProgress({ linearProgress: true, speed: 85 })
  const {
    start: startTwo,
    isRunning: isRunningTwo,
    progress: progressTwo,
  } = useProgress({ linearProgress: true, speed: 85, immediateComplete: true, onDone: startThree })
  const {
    start: startOne,
    isRunning: isRunningOne,
    progress: progressOne,
  } = useProgress({ linearProgress: true, speed: 85, immediateComplete: true, onDone: startTwo })

  if (!isRunningOne && progressOne !== 100) {
    startOne()
  }
  return (
    <Loading
      backgroundClassName={AutopilotRegistrationAndOnboardingStyles.robotBackground}
      showSupportButton={!isMobile}
      onCancel={handleBack}
      header="Analyzing your visual identity"
      description="We’re gathering data to build your visual identity"
      progresses={[
        {
          title: 'Selecting Colors',
          isRunning: isRunningOne,
          percentComplete: progressOne,
        },
        {
          title: 'Selecting Fonts',
          isRunning: isRunningTwo,
          percentComplete: progressTwo,
        },
        {
          title: 'Downloading Images',
          isRunning: isRunningThree,
          percentComplete: progressThree,
        },
      ]}
    />
  )
}
